import { Injectable, Injector, inject } from '@angular/core';
import { Router } from '@angular/router';

import { MatDialog } from '@angular/material/dialog';

import { FsApi } from '@firestitch/api';

import { Observable } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';

import { SessionService } from './session.service';


@Injectable({
  providedIn: 'root',
})
export class SignoutService {
  private _router = inject(Router);
  private _injector = inject(Injector);
  private _sessionService = inject(SessionService);
  private _dialogRef = inject(MatDialog);


  public destroy(): Observable<any> {
    return this._injector.get(FsApi)
      .post('auth/signout')
      .pipe(
        finalize(() => {
          this._sessionService.destroy();
        }),
      );
  }

  public signout$(redirect?: string): Observable<any> {
    return this.destroy()
      .pipe(
        tap(() => {
          this._dialogRef.closeAll();
          this._router.navigate(['/signin'], { queryParams: { redirect } });
        }),
      );
  }

  public signout(redirect?: string): void {
    this.signout$(redirect)
      .subscribe();
  }

}
